export interface LiveItem {
  id: number;
  time: string;
  scope: string;
  text: string;
  isImportant?: boolean;
}

export const liveFeed: LiveItem[] = [
  {
    id: 1,
    time: "09:02",
    scope: "要闻",
    text: "多地发布出行提示：受天气影响，今日部分高速公路入口实施临时管制，建议错峰出行。",
    isImportant: true,
  },
  {
    id: 2,
    time: "09:11",
    scope: "科技",
    text: "国产新机发布临近，供应链消息称备货量较上代提升约三成，首批货源充足。",
  },
  {
    id: 3,
    time: "09:27",
    scope: "娱乐",
    text: "电影《晚风号列车》口碑持续发酵，院线宣布加大排片，午后场次预售已基本售罄。",
    isImportant: true,
  },
  {
    id: 4,
    time: "09:42",
    scope: "财经",
    text: "多家机构上调国庆出游预测数据，热门航线票价较去年同期小幅回落，出游成本更友好。",
  },
  {
    id: 5,
    time: "10:05",
    scope: "社会",
    text: "新一轮社区食堂名单公布，新增二十余处助餐点，覆盖更多老旧小区及新交付社区。",
  },
  {
    id: 6,
    time: "10:23",
    scope: "体育",
    text: "乒超联赛今晚两场对决直播备受关注，官方平台预约观看人数已突破百万。",
  },
  {
    id: 7,
    time: "10:51",
    scope: "要闻",
    text: "城市通勤巴士试点首日运行平稳，早高峰上座率超八成，运营方将根据反馈优化班次。",
    isImportant: true,
  },
  {
    id: 8,
    time: "11:18",
    scope: "科技",
    text: "智能家居统一标准再添新成员，多家家电品牌宣布旗下主力产品将接入跨品牌互联。",
  },
  {
    id: 9,
    time: "11:40",
    scope: "财经",
    text: "国货美妆暑期大促数据出炉，面部护肤类目成交额同比上涨，成分党消费占比显著提升。",
  },
  {
    id: 10,
    time: "12:06",
    scope: "社会",
    text: "外卖平台高温关怀新举措今起全面生效，符合条件的骑手将自动获得高温补贴。",
    isImportant: true,
  },
  {
    id: 11,
    time: "12:35",
    scope: "娱乐",
    text: "热播剧《双城记》番外篇正式官宣开机，原班人马回归，预计明年春季与观众见面。",
  },
  {
    id: 12,
    time: "13:02",
    scope: "体育",
    text: "城市秋季马拉松报名火热，全马组别名额已告罄，组委会正统筹释放补报名额。",
  },
];